import { NodeModel } from "@minoru/react-dnd-treeview";
import { MenuItem } from "@mui/material";
import React, { type Dispatch, useState } from "react";
import { TagFromTree } from "../../../models/TrendingModelsV2";
import { NewFolderModal } from "./NewFolderModal";
import { RemoveFolderModal } from "./RemoveFolderModal";

interface Props {
	isOpen: boolean;
	tagNodeSelectedInTree: NodeModel<TagFromTree> | null;
	anchorPoint: { x: number; y: number } | null;
	getTagsTreeData: Function;
	setShowContextMenu: Dispatch<boolean>;
}

export const ContextMenu = ({
	isOpen,
	anchorPoint,
	tagNodeSelectedInTree,
	getTagsTreeData,
	setShowContextMenu,
}: Props) => {
	const [showNewTagModal, setShowNewTagModal] = useState<boolean>(false);
	const [showRemoveTagModal, setShowRemoveTagModal] = useState<boolean>(false);
	const isFolder = tagNodeSelectedInTree?.data?.TagTypeCode === "F";

	return (
		<>
			{isOpen && anchorPoint ? (
				<ul
					style={{
						top: anchorPoint.y,
						left: anchorPoint.x,
						fontSize: "0.875rem",
						backgroundColor: "#fff",
						borderRadius: "2px",
						padding: "5px 10px;",
						width: "140px",
						height: "auto",
						margin: "0",
						position: "fixed",
						boxShadow: "0 0 20px 0 #ccc",
						display: "flex",
						flexDirection: "column",
					}}
				>
					<MenuItem
						style={{ width: "100%", justifyContent: "left" }}
						onClick={() => setShowNewTagModal(true)}
					>
						New Folder
					</MenuItem>
					{tagNodeSelectedInTree && isFolder && (
						<MenuItem
							style={{ width: "100%", justifyContent: "left" }}
							onClick={() => setShowRemoveTagModal(true)}
						>
							Remove Folder
						</MenuItem>
					)}
				</ul>
			) : null}
			<NewFolderModal
				open={showNewTagModal}
				handleClose={(shouldUpdate) => {
					if (shouldUpdate) {
						getTagsTreeData();
					}
					setShowContextMenu(false);
					setShowNewTagModal(false);
				}}
				tagNodeSelectedInTree={tagNodeSelectedInTree}
			/>
			<RemoveFolderModal
				open={showRemoveTagModal}
				handleClose={(shouldUpdate) => {
					if (shouldUpdate) {
						getTagsTreeData();
					}
					setShowContextMenu(false);
					setShowRemoveTagModal(false);
				}}
				tagNodeSelectedInTree={tagNodeSelectedInTree}
			/>
		</>
	);
};
